import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";
import { Cookies } from "react-cookie";

export const addAmenities = createAsyncThunk("addAmenities", async (data) => {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");
    const response = await AxiosInstance.put(
      `${API_KEY}/api/society/add-amenities/${data.id}`,
      data.amenitiesData,
      {
        headers: { Authorization: `Barear ${token}` },
        "Content-Type": "application/json",
      }
    );

    return response;
  } catch (error) {
    if (error.response) {
      throw error.response.data.message;
    } else {
      throw error;
    }
  }
});

const initialState = {
  isLoading: false,
  addAmenitiesData: null,
  isError: false,
  errorMessage: "",
};
const addAmenitiesSlice = createSlice({
  name: "addAmenities",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(addAmenities.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(addAmenities.fulfilled, (state, action) => {
      state.isLoading = false;
      state.addAmenitiesData = action.payload;
    });
    builder.addCase(addAmenities.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default addAmenitiesSlice.reducer;
